// extracted by mini-css-extract-plugin
export var editButton = "_n2-0";